import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { PrismicRichText, useAllPrismicDocumentsByType, useSinglePrismicDocument } from '@prismicio/react';

import Contributor from './Contributor';

import '../assets/scss/disclaimer.scss';

const Disclaimer = () => {
    const [disclaimerDocument, { state: disclaimerDocumentState }] = useSinglePrismicDocument('disclaimer');
    const [contributorsDocument] = useAllPrismicDocumentsByType('contributor');
    if (disclaimerDocumentState === 'failed' || !disclaimerDocument || !disclaimerDocument.data) return <></>;

    const currentYear = new Date().getFullYear();

    const contributorOrderClasses = {
        umcg: 1,
        nefrovisie: 2,
        nvn: 3,
        nts: 4,
        ordina: 5
    };

    return (
        <div className="disclaimer">
            {/* Disclaimer */}
            {(disclaimerDocument.data['title'] || disclaimerDocument.data['description']) && (
                <Container maxWidth="lg" className="disclaimer__content">
                    {disclaimerDocument.data['title'] && (
                        <PrismicRichText field={disclaimerDocument.data['title']} />
                    )}

                    {disclaimerDocument.data['description'] && (
                        <PrismicRichText field={disclaimerDocument.data['description']} />
                    )}
                </Container>
            )}

            {/* Contributors */}
            {contributorsDocument && contributorsDocument.length && (
                <Container maxWidth="lg">
                    <Grid container spacing={2} justifyContent="center">
                        {contributorsDocument.filter((contributor) => contributor.uid === 'umcg' || contributor.uid === 'nefrovisie').map((contributor) => (
                            <Grid item xs={12} sm={6} md={3} key={contributor.id} style={{ order: contributorOrderClasses[contributor.uid] }}>
                                <Contributor
                                    id={contributor.id}
                                    name={contributor.data.name}
                                    description={contributor.data.description}
                                    link={contributor.data.link}
                                    image={contributor.data.image}
                                />
                            </Grid>
                        ))}
                    </Grid>

                    <Grid container spacing={2} justifyContent="center">
                        {contributorsDocument.filter((contributor) => contributor.uid !== 'umcg' && contributor.uid !== 'nefrovisie').map((contributor) => (
                            <Grid item xs={12} sm={6} md={3} key={contributor.id} style={{ order: contributorOrderClasses[contributor.uid] }}>
                                <Contributor
                                    id={contributor.id}
                                    name={contributor.data['name']}
                                    description={contributor.data['description']}
                                    link={contributor.data['link']}
                                    image={contributor.data['image']}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            )}

            {/* Copyright */}
            {(disclaimerDocument.data['copyright_title'] || disclaimerDocument.data['copyright_description']) && (
                <div className="disclaimer__copyright__container">
                    <Container maxWidth="lg" className="disclaimer__copyright">
                        {disclaimerDocument.data['copyright_title'] && (
                            <div className="disclaimer__copyright__title-year" data-prefix={`${currentYear} ©`}>
                                <PrismicRichText field={disclaimerDocument.data['copyright_title']} />
                            </div>
                        )}

                        {disclaimerDocument.data['copyright_description'] && (
                            <div className="disclaimer__copyright__links">
                                <PrismicRichText field={disclaimerDocument.data['copyright_description']} />
                            </div>
                        )}
                    </Container>
                </div>
            )}
        </div>
    );
};

export default Disclaimer;